import React from 'react';
import { Link } from 'react-router-dom';

const RedirectItem = ({ children }) => <Link to="/">{children}</Link>;

export default RedirectItem;
